import {changePasswordApi} from "../api/changePasswordApi";

export const setResponse = (response) => {
    return {
        type: "CHANGEPASSWORD",
        response
    }
}

export const changePassword = (params) => {
    return dispatch => {
        changePasswordApi(params).then((response) => {
            dispatch(setResponse(response));
        });
    }
}



// WEBPACK FOOTER //
// ./src/actions/changePassword.js